import React from 'react';
import { useSelector } from 'react-redux';
import { useTripStoreUpdater } from '../../hooks';
import { TripState } from '../../types/trip.store.type';
import { ImageCheckout } from '../../assets/images';
import '../../styles/_checkout-instructions.scss';
import { TranslationUtils } from '../../utils';
import { Loading } from '../../components';

export const CheckoutInstructions: React.FC = () => {
    useTripStoreUpdater(true);

    const trip = useSelector((store: { trip: TripState }) => store.trip);

    if (trip.isLoading) {
        return <Loading />;
    }

    if (!trip.departure) {
        return null;
    }

    return (
        <div>
            <h1 tabIndex={0} className="heading-large checkout-title">
                {TranslationUtils.get('checkout_instructions')}
            </h1>

            <div className="row checkout-mobile">
                <div className="col-12 col-md-7">
                    <div
                        className={'body-regular'}
                        tabIndex={0}
                        dangerouslySetInnerHTML={{ __html: trip.departure.substr(0, trip.departure.indexOf('</p><ul>')) }}
                    />
                </div>
                <div className="col-md-5">
                    <ImageCheckout className="d-none d-md-block" />
                </div>
            </div>
            <div
                className={'body-regular'}
                tabIndex={0}
                dangerouslySetInnerHTML={{ __html: trip.departure.substr(trip.departure.indexOf('</p><ul>')) }}
            />
        </div>
    );
};
